module.exports = __webpack_public_path__ + "static/media/self.e4479a4a.svg";